/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex(
      item => item.url == payload.url
    );

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(
        state.navbarSearchAndPinList["pages"].data[index]
      );
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        item => item.url == payload.url
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map(i => {
      if (list.indexOf(i) > -1) downToUp = true;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_SIZE(state, val) {
    state.windowWidth = val.width;
    state.windowHeight = val.height;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },
  UPDATE_DEVICE_INFO(state) {

    let deviceType = '';
    if( navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPod') >= 0 ){
      deviceType = 'iPhone';
    } else if ((navigator.userAgent.indexOf('Android') >= 0 && navigator.userAgent.indexOf('Mobile') >= 0)){
      deviceType = 'Android';
    }else if (navigator.userAgent.indexOf('iPad') >= 0 ) {
      deviceType = 'iPad';
    }else if (navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.indexOf('Chrome') == -1 &&
     state.is_touch_device === true ) {
      deviceType = 'iPad';
    } else {
      deviceType = 'PC';
    }

    let browser = '';
    const agent = window.navigator.userAgent.toLowerCase()
    if (agent.indexOf("msie") != -1 || agent.indexOf("trident") != -1) {
      browser = 'MSIE';
    } else if (agent.indexOf("edg") != -1 || agent.indexOf("edge") != -1) {
      browser = 'Edge';
    } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
      browser = 'Opera';
    } else if (agent.indexOf("chrome") != -1) {
      browser = 'Chrome';
    } else if (agent.indexOf("safari") != -1) {
      browser = 'Safari';
    } else if (agent.indexOf("firefox") != -1) {
      browser = 'FireFox';
    } else {
      browser = 'unknown';
    }

    let orientation = '';
    if ( window.orientation === 0 || window.orientation === 180 ) {
      orientation = 'portrait';
    } else if ( window.orientation === -90 || window.orientation === 90 ) {
      orientation = 'landscape';
    } else if  ( window.innerWidth < window.innerHeight) {
      orientation = 'portrait';
    } else {
      orientation = 'landscape';
    }

    const deviceInfo = {
      deviceType:  deviceType,
      browser:     browser,
      userAgent:   navigator.userAgent,
      orientation: orientation,
    }; 
    state.deviceInfo = deviceInfo;
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user-management info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    // Get Data localStorage
    let userInfo =
      JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser;

    for (const property of Object.keys(payload)) {
      if (payload[property] != null) {
        // If some of user-management property is null - user-management default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property];

        // Update key in localStorage
        userInfo[property] = payload[property];
      }
    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },

  SET_ID_TOKEN(state, payload) {
    state.auth.idToken = payload.idToken;
  },

  SET_USER(state, payload) {
    state.auth.user = payload.user;
  },

  SET_ADDONS(state, payload) {
    state.addons = payload.addons;
  },

  SET_IS_FREE(state, payload) {
    state.isFree = payload.isFree;
  }
};

export default mutations;
